import { execOnLoad } from '@general/helpers';
import { throttle } from 'lodash';
import './header.scss';
import { openModal } from '@components/modals';
import { afterCartChangeType, getCart } from '@services/cart';
import breakpoints from 'breakpoints';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initHeader = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const backgroundContainer = sectionContainer.querySelector(
    '.header__background',
  );
  if (backgroundContainer) {
    const resizeCallback = throttle(
      () =>
        document.documentElement.style.setProperty(
          '--header-height',
          `${backgroundContainer.clientHeight}px`,
        ),
      500,
    );
    resizeCallback();
    window.addEventListener('resize', resizeCallback);
  }

  const cartIcon = sectionContainer.querySelector('.header__action--cart');
  const minicart = document.querySelector('#MinicartDrawer');
  if (cartIcon && minicart)
    cartIcon.addEventListener('click', (e) => {
      e.preventDefault();
      if (!document.body.classList.contains('body__cart')) openModal(minicart);
    });

  const cartCounter = sectionContainer.querySelector(
    '.header__action-cart-counter',
  );
  if (cartCounter) {
    document.addEventListener(afterCartChangeType, async () => {
      const cart = await getCart();
      if (cart) cartCounter.innerText = `${cart.item_count}`;
    });
  }

  sectionContainer.addEventListener('mouseenter', (e) => {
    if (e?.sourceCapabilities?.firesTouchEvents && parseInt(breakpoints.lg))
      return;
    document.body.classList.add('opacize');
    document.body.classList.add('keep-focus');
  });

  sectionContainer.addEventListener('mouseleave', (e) => {
    if (e?.sourceCapabilities?.firesTouchEvents && parseInt(breakpoints.lg))
      return;
    document.body.classList.remove('keep-focus');
    if (document.body.classList.contains('headroom--top')) {
      document.body.classList.remove('opacize');
    }
  });

  const searchIcon = sectionContainer.querySelector('.header__action--search');
  const mainInput = sectionContainer.querySelector(
    '#SearchDrawer input[name="q"]',
  );
  if (searchIcon)
    searchIcon.addEventListener('click', (e) => {
      e.preventDefault();
      openModal('#SearchDrawer');
      mainInput.focus();
    });
};

execOnLoad(window.dAgency.initHeader, '.header__section');
